import { render, staticRenderFns } from "./ErrorCompra.vue?vue&type=template&id=f7cf93b4"
import script from "./ErrorCompra.vue?vue&type=script&lang=js"
export * from "./ErrorCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports